__turbopack_context__.v({
  "party-details": "PartyDetails-module-scss-module__J2JEeG__party-details",
  "party-details__cta": "PartyDetails-module-scss-module__J2JEeG__party-details__cta",
  "party-details__eyebrow": "PartyDetails-module-scss-module__J2JEeG__party-details__eyebrow",
});
